import EntityCard, { EntityCardProps, HoverAction, MainButton } from "./EntityCard";

export default EntityCard;
export type { EntityCardProps, HoverAction, MainButton };
